import { supportsSessionStorage, getQueryStringParameters } from 'utilities/browser';

function formatReferringSortData (sortPath, sortPosition, sortSku, listType) {

	if (!supportsSessionStorage()) {

		return null;

	}

	let sortPathPosition = '';
	let prevUrl = document.referrer;
	let formattedSortPath = null;

	// if adding from quick look directly
	if (document.location.pathname === '/popups/QuickLook.aspx' && window.parent.$('#bdProdSort').length) {

		prevUrl = window.parent.location.href;

	}

	// if adding from PDP after coming from quick look
	if (prevUrl.includes('/popups/QuickLook.aspx')) {

		prevUrl = sortPath;

	}

	if (prevUrl) {

		formattedSortPath = prevUrl.replace(/^(?:\/\/|[^/]+)*\//, '');

		if (formattedSortPath.indexOf('/') !== 0) {

			formattedSortPath = `/${formattedSortPath}`;

			const queryParamIndex = formattedSortPath.indexOf('?');

			if (queryParamIndex !== -1) {

				const queryStringParams = getQueryStringParameters(formattedSortPath.substring(queryParamIndex));

				formattedSortPath = formattedSortPath.substring(0, queryParamIndex);

				if (queryStringParams.sfp) {

					formattedSortPath = `${formattedSortPath}?sfp=${queryStringParams.sfp}`;

				}

			}

		}

	}

	// if coming from sort page or sfp page and sortPosition/sortSku exists in session
	if (
		formattedSortPath
		&& (formattedSortPath.indexOf('/c/') === 0
			|| formattedSortPath.indexOf('/s/') === 0
			|| formattedSortPath.indexOf('/shop-by-room/') === 0
			|| formattedSortPath.indexOf('/sfp/') === 0
			|| formattedSortPath.indexOf('/image-search/') === 0)
		&& sortSku
	) {

		sortPathPosition = {
			SortPath: formattedSortPath,
			SortPosition: sortPosition,
			SortSku: sortSku,
			ListType: listType
		};

	}

	return sortPathPosition;

}

export default formatReferringSortData;
